import { useAuth } from '@/contexts/auth-context';
import { useInvitationStoreSelector } from '@/contexts/invitation-context';
import type { PayloadLocale } from '@fluenceur/types';

/**
 * Shared email-language state for the outreach compose surfaces (the affiliation
 * email step, the sponsored proposal module, and the shared composer they both
 * embed). The override lives in the wizard store (`messageLanguage`); the
 * brand's preferred locale is the default. Kept in one place so the composer's
 * language toggle and each caller's template fetch / subject resolution read the
 * exact same resolved language.
 */
export const useOutreachLanguage = () => {
  const { user } = useAuth();
  const messageLanguage = useInvitationStoreSelector((state) => state.messageLanguage);
  const setMessageLanguage = useInvitationStoreSelector((state) => state.setMessageLanguage);

  const brandDefaultLanguage: PayloadLocale =
    user?.currentBrand?.settings?.preferredLanguage ?? 'en';
  const selectedLanguage: PayloadLocale = messageLanguage ?? brandDefaultLanguage;

  return {
    setMessageLanguage,
    brandDefaultLanguage,
    selectedLanguage,
    /** True whenever the brand has explicitly overridden the locale. */
    languageToggleEnabled: messageLanguage !== undefined,
  };
};
